// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__josv5","animation":"styles_animation__LThM_"};